import React, { useCallback, useMemo, useRef, useState } from "react";
import "./index.scss";
import Autocomplete, { Button } from "devextreme-react/autocomplete";
import { IMdaeDateAutoCompleteProps } from "./index";
import { Calendar, Popup } from "devextreme-react";
import { convertDateFormat } from "../../../utils/dateUtils";
import { DISABLE_ANIMATION_CONFIG } from "../popup/component";

const MdaeDateAutoComplete: React.FC<IMdaeDateAutoCompleteProps> = (props) => {
  const [autoCompleteDateValue, setAutoCompleteDateValue] = useState(
    props.value
  );
  const [isCalenderVisible, setIsCalenderVisible] = useState(false);
  const calenderInstanceRef = useRef(null);

  const onCalendarShowing = useCallback(() => {
    if (
      autoCompleteDateValue &&
      convertDateFormat(autoCompleteDateValue, "MM/DD/YYYY") != "Invalid Date"
    )
      calenderInstanceRef.current.instance.option(
        "value",
        new Date(autoCompleteDateValue)
      );
    setIsCalenderVisible(true);
  }, [autoCompleteDateValue, calenderInstanceRef]);

  const onCalendarHiding = useCallback(() => {
    setIsCalenderVisible(false);
  }, []);

  const onCalenderButtonClick = useCallback(() => {
    setIsCalenderVisible(!isCalenderVisible);
  }, []);

  const onCalendarValueChanged = useCallback((e) => {
    const value = convertDateFormat(e.value, "MM/DD/YYYY");
    setIsCalenderVisible(false);
    if (typeof props.onValueChanged === "function")
      props.onValueChanged({ ...e, value } as any);
    onValueChanged(value);
  }, []);

  const onAutocompleteValueChanged = useCallback((e) => {
    if (typeof props.onValueChanged === "function")
      props.onValueChanged({
        ...e,
        value: convertDateFormat(e.value, "MM/DD/YYYY"),
      } as any);
    onValueChanged(e.value);
  }, []);

  const calenderButtonOptions = useMemo(
    () => ({
      icon: "event",
      stylingMode: "text",
      onClick: onCalenderButtonClick,
      elementAttr: {
        id: props.id,
      },
    }),
    [props.id]
  );

  const onValueChanged = useCallback((value) => {
    setAutoCompleteDateValue(value);
  }, []);

  return (
    <div className={"sys-mdae-autocomplete-date-picker-container "}>
      <Autocomplete
        {...props}
        value={autoCompleteDateValue}
        text={convertDateFormat(autoCompleteDateValue, "MM/DD/YYYY")}
        onValueChanged={onAutocompleteValueChanged}
      >
        <Button name={"CalanederButton"} options={calenderButtonOptions} />
      </Autocomplete>

      <Popup
        wrapperAttr={{ class: "dx-dropdowneditor-overlay" }}
        width={"auto"}
        height={"auto"}
        visible={isCalenderVisible}
        hideOnOutsideClick
        showTitle={false}
        position={{
          at: "bottom",
          my: "top",
          of: "#" + props.id,
        }}
        animation={DISABLE_ANIMATION_CONFIG}
        onHiding={onCalendarHiding}
        onShowing={onCalendarShowing}
      >
        <Calendar
          ref={calenderInstanceRef}
          onValueChanged={onCalendarValueChanged}
        />
      </Popup>
    </div>
  );
};
export default MdaeDateAutoComplete;
